var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.255 11.662-9.19 9.19a6.003 6.003 0 0 1-8.49-8.49l9.19-9.19a4.002 4.002 0 1 1 5.66 5.66l-9.2 9.19a2.001 2.001 0 1 1-2.83-2.83l8.49-8.48",
    stroke: "inherit",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgUpload as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M22.2547 11.6623L13.0647 20.8523C10.7203 23.1967 6.91919 23.1967 4.57474 20.8523C2.23029 18.5078 2.23029 14.7067 4.57474 12.3623L13.7647 3.17229C15.3277 1.60932 17.8618 1.60932 19.4247 3.17229C20.9877 4.73525 20.9877 7.26932 19.4247 8.83229L10.2247 18.0223C9.44326 18.8038 8.17623 18.8038 7.39474 18.0223C6.61326 17.2408 6.61326 15.9738 7.39474 15.1923L15.8847 6.71229' stroke='inherit' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";